import { AnnotationStatus } from '@rossum/api-client/shared';

export const defaultTabStatuses: Array<AnnotationStatus> = [
  'to_review',
  'reviewing',
  'importing',
  'failed_import',
];

const postponeStatuses: Array<AnnotationStatus> = ['postponed'];
const confirmedStatuses: Array<AnnotationStatus> = ['confirmed'];

const deletedStatuses: Array<AnnotationStatus> = ['deleted'];
const rejectedStatuses: Array<AnnotationStatus> = ['rejected'];
const exportedStatuses: Array<AnnotationStatus> = [
  'exporting',
  'exported',
  'failed_export',
];
const inWorkflowStatuses: Array<AnnotationStatus> = ['in_workflow'];

export const allTabStatuses: Array<AnnotationStatus> = [
  defaultTabStatuses,
  postponeStatuses,
  confirmedStatuses,
  exportedStatuses,
  deletedStatuses,
  rejectedStatuses,
  inWorkflowStatuses,
].flat();
